import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
 
const AdditionalPopupTentative = ({ isOpen, onClose }) => {
    const modalStyles = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
       // width: '30%',
        height: '190px',
        padding: '20px',
        border: '1px solid #d9d7d7',
        borderRadius: '5px',
        boxSizing: 'border-box',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };
 
    return (
        <Popup open={isOpen} onClose={onClose} modal contentStyle={modalStyles}>
            {close => (
                <div className="modal" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
                   
                   
                    <div className="content">
                    <h5 className='popupTitle'>Tentative!</h5>
                       <p> You are Tentativly to  this event.</p>
                       <p> If your plans change, please contact Admin!</p>
                    <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                   
                    <button
                        className="btn btn-save"
                        onClick={close}
                    >
                        CLOSE
                    </button>
                        </div>
                        </div>
                   
                    </div>
               
            )}
        </Popup>
    );
};
 
export default AdditionalPopupTentative;